/* 🤖 this file was generated by svg-to-ts */
export const matIconBurstMode: {
  name: 'burst-mode';
  data: string;
} = {
  name: 'burst-mode',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M1 5h2v14H1zm4 0h2v14H5zm17 0H10c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-1 12H11V7h10v10zm-3.57-4.38-2 2.57L14 13.47l-2 2.52h8z"/></svg>`
};
